<template>
  <div class="tag-form">
    <form @submit.prevent="handleSubmit">
      <div v-if="editTag">
        <h2 class="text-center">{{ "Edit Tag - " + tagSlug }}</h2>
      </div>
      <div v-else>
        <h2 class="text-center">Add Tag</h2>
      </div>
      <section class="my-5">
        <div class="flex items-center w-3/4">
          
            <label class="ml-20 mr-8 font-bold text-lg" for="tag-name"
              >Name<span class="text-red">*</span></label
            >
            <div class="w-full">
            <input
              id="tag-name"
              v-model="tagName"
              v-validate="'required'"
              type="text"
              placeholder="Add a Tag Name"
              name="name"
            />
            <small class="err-msg text-red block mt-2">
              {{ veeValidateErrors.first("name") }}
            </small>
          </div>
        </div>
      </section>
      <div class="text-right p-4 mt-5 mr-10">
        <button
          type="submit"
          class="text-right bg-green hover:bg-green-dark px-4 py-2 text-white"
        >
          {{ editTag ? "Update Tag" : "Create Tag" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      tagId: "",
      tagName: "",
      tagSlug: "",
    }
  },
  computed: {
    editTag() {
      return !!this.$route.params.id
    },
  },
  async created() {
    if (this.editTag) {
      this.getTag()
    }
  },
  methods: {
    handleSubmit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.$noty.error("Please fix the errors and try again")
          return
        }

        const payload = {}
        payload.name = this.tagName

        this.axios({
          method: this.editTag ? "PUT" : "post",
          url: `${siteConfig.siteURL}question_bank/tags${
            this.editTag ? `/${this.$route.params.id}` : ""
          }`,
          data: payload,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
            "x-api-key": process.env.VUE_APP_API_KEY_SECRET_TOKEN,
          },
        })
          .then((res) => {
            this.$router.push({ name: "QuestionBankTagList" })
            this.$noty.success("Successful", {
              layout: "bottomLeft",
              theme: "relax",
              timeout: 1000,
            })
          })
          .catch((err) => {
            this.$noty.error(
              `Failed to Add/Update the Tag: ${err.response.data.message}`
            )
          })
      })
    },
    getTag() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}question_bank/tags/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then((res) => {
          const data = res.data.tag
          this.tagId = data.id
          this.tagName = data.name
          this.tagSlug = data.slug
        })
        .catch((error) => {
          this.$noty.error(`Failed to get the Tag ${error}`)
        })
    },
  },
}
</script>

<style scoped>
.tag-form {
  max-width: 700px;
  margin: auto;
}
</style>
